import * as React from 'react';
import { renderDefinedTrue } from '../../utils/react';
// @ts-ignore
import { EValidationTestType } from '../../utils/validationConfigs';
import { ValidationMessage, ValidationMessageProps } from '../ValidationMessage';
import { EInputType, InputContent } from './Content';
import { InputWrapper } from './InputWrapper';
import { InputLabel } from './Label';
import { SwitchSize, SwitchType } from './Switch';

export enum EInputTextType {
  Standard = 'Standard',
  Material = 'Material',
}

export interface IInputConfig {
  checkboxLabel?: any;
  checked?: boolean;
  clearable?: boolean;
  cols?: number;
  customComponent?: JSX.Element;
  defaultChecked?: boolean;
  defaultValidationMessageConfig?: ValidationMessageProps;
  defaultValue?: any;
  disabled?: boolean;
  dropdownLabel?: string;
  file?: Object;
  filtering?: boolean;
  forcedValue?: any;
  id?: string;
  inputTextType?: EInputTextType;
  inputType?: EInputType;
  inputWrapperClass?: string;
  inputWrapperStyle?: React.CSSProperties;
  isFocused?: boolean;
  isLoading?: boolean;
  isOpen?: boolean;
  label?: string | JSX.Element;
  max?: number;
  maxLength?: number;
  min?: number;
  minDate?: Date;
  maxDate?: Date;
  name?: string;
  onBlur?: any;
  onChange?: (name: any, value?: any, file?: any, removeFile?: any) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onDropdownOpen?: (isOpen: boolean) => void;
  onFocus?: any;
  onSelected?: any;
  placeholder?: string;
  radioOptions?: IInputConfig[];
  readOnly?: boolean;
  required?: boolean;
  rows?: number;
  selectOptions?: IInputConfig[];
  step?: string;
  style?: any;
  switchType?: SwitchType;
  type?: string;
  validationMessageConfig?: ValidationMessageProps;
  validationTests?: EValidationTestType[];
  value?: any;
  icon?: any;
  children?: any;
  size?: SwitchSize;
  onKeyPress?: any;
  radioExtraStyles?: string;
}

export const Input = (props: IInputConfig) => {
  const { validationMessageConfig, inputWrapperStyle, children, style, inputWrapperClass } = props;
  return (
    <InputWrapper inputWrapperStyle={inputWrapperStyle} inputWrapperClass={inputWrapperClass || ''}>
      {renderDefinedTrue(children, () => (
        <InputLabel style={style || {}}>{children}</InputLabel>
      ))}
      {renderDefinedTrue(validationMessageConfig, () => {
        return <ValidationMessage {...validationMessageConfig} />;
      })}
      <InputContent inputConfig={props} />
    </InputWrapper>
  );
};
